module.exports = __webpack_public_path__ + "img/image (20).fd9b6650.png";